import {
  use_circle_progress_style_default
} from "./chunk-Z5UCIXBT.mjs";
import {
  Circle
} from "./chunk-XFIPMP2W.mjs";
import {
  Shape
} from "./chunk-3XHB3THH.mjs";
import {
  circularProgressCX,
  trackColorSx
} from "./chunk-ONZLO3HG.mjs";

// src/circular/CircularProgress.tsx
import { cx, forwardRef, julo } from "@julo-ui/system";
import { jsx, jsxs } from "react/jsx-runtime";
var CircularProgress = forwardRef(
  (props, ref) => {
    const {
      className,
      size = "48px",
      max = 100,
      min = 0,
      valueText,
      getValueText,
      value,
      capIsRound,
      children,
      thickness = "10px",
      color = "var(--colors-primary-30)",
      trackColor,
      isIndeterminate,
      variant = "primary",
      ...resProps
    } = props;
    const { progress, indicatorProps } = use_circle_progress_style_default({
      max,
      min,
      valueText,
      value,
      getValueText,
      isIndeterminate
    });
    return /* @__PURE__ */ jsxs(
      julo.div,
      {
        ref,
        className: cx("julo-progress", className),
        ...progress.bind,
        ...resProps,
        __css: circularProgressCX,
        children: [
          /* @__PURE__ */ jsxs(Shape, { size, isIndeterminate, children: [
            /* @__PURE__ */ jsx(
              Circle,
              {
                sx: {
                  ...trackColorSx[variant],
                  ...trackColor && { stroke: trackColor }
                },
                strokeWidth: thickness,
                className: "julo-progress__track"
              }
            ),
            /* @__PURE__ */ jsx(
              Circle,
              {
                stroke: color,
                strokeWidth: thickness,
                className: "julo-progress__indicator",
                strokeLinecap: capIsRound ? "round" : void 0,
                opacity: progress.value === 0 && !isIndeterminate ? 0 : void 0,
                ...indicatorProps
              }
            )
          ] }),
          children
        ]
      }
    );
  }
);
CircularProgress.displayName = "CircularProgress";
var CircularProgress_default = CircularProgress;

export {
  CircularProgress_default
};
